import { WorkspaceActionTypes } from './workspace.actions'
import { WorkspaceAction, WorkspaceState } from './workspace.type'

const MAX_OPEN_TABS = 10

export function WorkspaceReducer(state: WorkspaceState, action: WorkspaceAction): WorkspaceState {
  const { tab, filters, type } = action
  switch (type) {
    case WorkspaceActionTypes.updateTab: {
      if (tab) {
        const { tabs } = state
        let currentTabIndex = tabs.findIndex(
          (t) => t.bookablePersonId === tab.bookablePersonId && t.bookablePersonType === tab.bookablePersonType,
        )
        if (currentTabIndex > -1) {
          tabs[currentTabIndex] = tab
        }
        return { ...state, tabs }
      }
    }
    case WorkspaceActionTypes.openTab: {
      if (tab) {
        const { tabs, recentlyClosedTabs } = state
        const activeTabId = tab.bookablePersonId
        const activeTabType = tab.bookablePersonType
        tab.lastAccessedTime = new Date()
        const tabExistIndex = tabs.findIndex(
          (t) => t.bookablePersonId === tab.bookablePersonId && t.bookablePersonType === tab.bookablePersonType,
        )
        if (tabExistIndex < 0) {
          tabs.unshift(tab)
        } else {
          tabs[tabExistIndex] = tab
        }

        // Remove open tab from Closed list
        const tabExistIndexInClosedList = recentlyClosedTabs.findIndex(
          (t) => t.bookablePersonId === tab.bookablePersonId && t.bookablePersonType === tab.bookablePersonType,
        )
        if (tabExistIndexInClosedList >= 0) {
          recentlyClosedTabs.splice(tabExistIndexInClosedList, 1)
        }

        if (tabs.length > MAX_OPEN_TABS) {
          tabs.sort((tab1, tab2) => {
            if (!tab1.lastAccessedTime) return 1
            if (!tab2.lastAccessedTime) return -1
            if (tab1 === tab2) {
              return 0
            }
            return tab1 < tab2 ? -1 : 1
          })
          const toBeRemovedTabs = tabs.slice(recentlyClosedTabs.length - MAX_OPEN_TABS) // Removes last n number of tabs above Max levels
          tabs.splice(-(tabs.length - MAX_OPEN_TABS)) // Removes last n number of tabs above Max levels
          recentlyClosedTabs.unshift(...toBeRemovedTabs) // Inserts into start of closed tabs
          if (recentlyClosedTabs.length > MAX_OPEN_TABS) {
            recentlyClosedTabs.splice(recentlyClosedTabs.length - MAX_OPEN_TABS)
          }
        }
        return { ...state, activeTabId, activeTabType, tabs, recentlyClosedTabs }
      }
    }
    case WorkspaceActionTypes.closeTab: {
      if (tab) {
        const { tabs, recentlyClosedTabs } = state
        const closeTabIndex = tabs.findIndex(
          (t) => t.bookablePersonId === tab.bookablePersonId && t.bookablePersonType === tab.bookablePersonType,
        )
        if (closeTabIndex > -1) {
          // Move closed tab to recently closed tab
          const toBeClosedTab = { ...tab }
          const tabExistIndex = recentlyClosedTabs.findIndex(
            (t) => t.bookablePersonId === tab.bookablePersonId && t.bookablePersonType === tab.bookablePersonType,
          )
          // Remove the tab from Closed tab list
          if (tabExistIndex >= 0) {
            recentlyClosedTabs.splice(tabExistIndex, 1)
          }
          if (recentlyClosedTabs.length > MAX_OPEN_TABS) {
            recentlyClosedTabs.splice(recentlyClosedTabs.length - MAX_OPEN_TABS)
          }
          recentlyClosedTabs.unshift(toBeClosedTab)
          tabs.splice(closeTabIndex, 1)
        }
        if (tabs.length) {
          let lastAccessedTab = tabs[0]
          tabs.forEach((t) => {
            if (t.lastAccessedTime > lastAccessedTab.lastAccessedTime) {
              lastAccessedTab = t
            }
          })

          const activeTabId = lastAccessedTab.bookablePersonId
          return { ...state, tabs, activeTabId, recentlyClosedTabs }
        }

        return { ...state, tabs, recentlyClosedTabs }
      }
    }
    case WorkspaceActionTypes.closeAllTabs: {
      const { tabs } = state
      return { ...state, tabs: [], activeTabId: null, activeTabType: null, recentlyClosedTabs: [...tabs] }
    }
    case WorkspaceActionTypes.updateFilters: {
      const { activeTabId, activeTabType, tabs } = state
      if (filters && activeTabId) {
        const activeTab = tabs.find((t) => t.bookablePersonId === activeTabId && t.bookablePersonType === activeTabType)
        if (activeTab) {
          activeTab.potentialBookingFilters = {
            ...activeTab.potentialBookingFilters,
            ...filters,
            listView: filters.listView || activeTab.potentialBookingFilters?.listView || true,
          }
        }
      }

      return { ...state, tabs }
    }

    default: {
      return state
    }
  }
}
